import React from "react";

interface Category {
  id: string;
  name: string;
  parentCategoryId?: string;
}

interface Props {
  categories: Category[];
  selected: string[];
  onChange: (id: string) => void;
  className?: string;
  onClose?: () => void; // new
}


const CategorySidebar: React.FC<Props & { className?: string }> = ({ categories, selected, onChange, className,onClose }) => {
  const parents = categories.filter(c => !c.parentCategoryId);
  return (
    <aside className={`category_sidebar ${className || ""}`}>
  {/* Close Button for Mobile */}
  {onClose && (
    <div className="sidebar-close-btn">
      <button onClick={onClose}>✖ Close</button>
    </div>
  )}
  {parents.map(parent => (
    <div key={parent.id} className="category_block">
      <h4 className="category_heading">{parent.name}</h4>
      <ul className="subcategory_list">
        {categories
          .filter(sub => sub.parentCategoryId === parent.id)
          .map(sub => (
            <li key={sub.id}>
              <label>
                <input
                  type="checkbox"
                  checked={selected.includes(sub.id)}
                  onChange={() => onChange(sub.id)}
                />
                {sub.name}
              </label>
            </li>
          ))}
      </ul>
    </div>
  ))}
</aside>

  );
};

export default CategorySidebar;